import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Nimeä tämä tulostustyö',
      placeholder: 'A5-esite - erikoistarjous',
    },
    format: {
      label: 'Tuotetyyppi',
      placeholder: 'Valitse tuotetyyppi',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Esite (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Esite (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Tarra (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Ovitarra (30x30cm)',
      },
    },
    file: {
      label: 'Tiedosto',
    },
  },
  buttons: {
    upload: 'Napsauta tai vedä ladataksesi tiedoston',
    save: 'Tallenna',
  },
  toasts: {
    changes_got_saved: 'Muutokset tallennettu!',
  },
};
